import React, { useState, useRef, useMemo } from 'react';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { RoomInforDto, RoomPeoplesDto } from '../../model/room.dto';
import { userIdState } from '../../atom/TokenAtom';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  orderAutoSortStateRecoil,
} from '../../atom/ModalAtom';
import { socketio } from '../../api/socket.api';
import { roomAPI } from '../../api/axiosIndex';
import { Icon } from '../../component/Icon';

interface OrderAutoSortProps {
  pickLineId: number | null;
  roomInfor: RoomInforDto | null;
  roomId: string | null;
  onListUpdate: () => void;
}

const OrderAutoSort = ({
  pickLineId,
  roomInfor,
  roomId,
  onListUpdate,
}: OrderAutoSortProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);

  const setModalState = useSetRecoilState(orderAutoSortStateRecoil);

  const [fixOrderNum, setFixOrderNum] = useState(
    roomInfor?.lines.find((list) => list.id === pickLineId)?.fixedTurn,
  );
  const [autoState, setAutoState] = useState(
    roomInfor?.lines.find((list) => list.id === pickLineId)?.autoSort,
  );

  const fixOrderBoxRef = useRef<HTMLSelectElement>(null);
  const autoBtnRef = useRef<HTMLInputElement>(null);

  const handleFixOrderChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFixOrderNum(Number(e.target.value));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAutoState(e.target.checked);

    if (e.target.checked) {
      if (fixOrderBoxRef.current) {
        fixOrderBoxRef.current.disabled = false;
      }
    } else {
      if (fixOrderBoxRef.current) {
        fixOrderBoxRef.current.disabled = true;
      }
    }
  };

  const handleConfirm = async () => {
    try {
      await roomAPI.putOrderAutoSort(
        Number(pickLineId),
        Boolean(autoState),
        Number(fixOrderNum),
      );
      socketio.participation(Number(roomId));
      socketio.entry(Number(pickLineId));
      setModalState(false);
      onListUpdate();

      if (autoState) {
        setConfirm('순번 자동 정렬이 ON 되었습니다.');
      } else {
        setError('순번 자동 정렬이 OFF 되었습니다.');
      }
    } catch {
      setError('순번 자동 정렬 설정에 실패하였습니다.');
    }
  };

  return (
    <>
      <InputModal
        title="순번 자동 정렬"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>
              고정 순번
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.SelectType1>
              <select
                ref={fixOrderBoxRef}
                onChange={handleFixOrderChange}
                value={fixOrderNum}
                className="selected"
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
              </select>
              <span className="img-box">
                <Icon name="ArrowBottomIcon" size="100%" color="#D8D7DC" />
              </span>
            </CS.SelectType1>
          </li>
          <li>
            <h2>OFF/ON</h2>
            <CS.CtrlBox>
              <input
                type="checkbox"
                id="auto_state"
                ref={autoBtnRef}
                checked={autoState}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="auto_state"></label>
            </CS.CtrlBox>
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default OrderAutoSort;
